var _dec, _class, _class2, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import { inject, observer } from 'mobx-react';

import { subscribe } from 'sdc-publish-subscribe';

import { Missing } from './missing';

export var Label = (_dec = inject('labelsStore', 'languagesStore'), _dec(_class = observer(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(Label, _React$Component);

  function Label() {
    _classCallCheck(this, Label);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Label.renderAll = function renderAll() {
    Label.instances.forEach(function (instance) {
      return instance.forceUpdate();
    });
  };

  Label.prototype.componentDidMount = function componentDidMount() {
    Label.instances.push(this);
  };

  Label.prototype.componentWillUnmount = function componentWillUnmount() {
    Label.instances.splice(Label.instances.indexOf(this), 1);
  };

  Label.prototype.render = function render() {
    var _props = this.props,
        labelsStore = _props.labelsStore,
        languagesStore = _props.languagesStore,
        _props$language = _props.language,
        language = _props$language === undefined ? languagesStore.selectedLanguage : _props$language,
        _props$className = _props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$style = _props.style,
        style = _props$style === undefined ? {} : _props$style,
        _props$as = _props.as,
        T = _props$as === undefined ? 'span' : _props$as,
        padded = _props.padded,
        value = _props.value,
        onClick = _props.onClick,
        replacements = _objectWithoutProperties(_props, ['labelsStore', 'languagesStore', 'language', 'className', 'style', 'as', 'padded', 'value', 'onClick']);

    var label = value ? labelsStore.textFrom(language, value, replacements) : '';
    if (label === undefined && value.indexOf('.') < 0) label = value;
    if (/\.undefined$/.test(value) || /\.null$/.test(value)) label = '-';
    var padding = padded ? ' ' : '';

    return label !== undefined ? React.createElement(
      T,
      { className: className, style: style, onClick: onClick },
      padding,
      label,
      padding
    ) : React.createElement(Missing, { className: className, style: style, value: value });
  };

  return Label;
}(React.Component), _class2.instances = [], _temp)) || _class) || _class);

subscribe('sdc-i18n-renderAll', function () {
  Label.renderAll();
});